/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type resumeSimulatorSpacePublicMutationVariables = {|
  category?: ?string,
  spaceRef?: ?string,
  riderRef?: ?string,
  riders?: ?number,
  datesSelected?: ?any,
|};
export type resumeSimulatorSpacePublicMutationResponse = {|
  +simulatorSpacePublicMutation: ?{|
    +days: ?number,
    +price: ?{|
      +excl_tax: ?number
    |},
    +priceByDates: ?{|
      +excl_tax: ?number,
      +incl_tax: ?number,
    |},
    +riderFees: ?{|
      +excl_tax: ?number,
      +incl_tax: ?number,
    |},
    +riderOwing: ?{|
      +excl_tax: ?number,
      +incl_tax: ?number,
    |},
  |}
|};
export type resumeSimulatorSpacePublicMutation = {|
  variables: resumeSimulatorSpacePublicMutationVariables,
  response: resumeSimulatorSpacePublicMutationResponse,
|};
*/


/*
mutation resumeSimulatorSpacePublicMutation(
  $category: String
  $spaceRef: String
  $riderRef: String
  $riders: Int
  $datesSelected: JSONObject
) {
  simulatorSpacePublicMutation(category: $category, spaceRef: $spaceRef, riderRef: $riderRef, riders: $riders, datesSelected: $datesSelected) {
    days
    price {
      excl_tax
    }
    priceByDates {
      excl_tax
      incl_tax
    }
    riderFees {
      excl_tax
      incl_tax
    }
    riderOwing {
      excl_tax
      incl_tax
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "category"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "datesSelected"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "riderRef"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "riders"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "spaceRef"
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "excl_tax",
  "storageKey": null
},
v6 = [
  (v5/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "incl_tax",
    "storageKey": null
  }
],
v7 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "category",
        "variableName": "category"
      },
      {
        "kind": "Variable",
        "name": "datesSelected",
        "variableName": "datesSelected"
      },
      {
        "kind": "Variable",
        "name": "riderRef",
        "variableName": "riderRef"
      },
      {
        "kind": "Variable",
        "name": "riders",
        "variableName": "riders"
      },
      {
        "kind": "Variable",
        "name": "spaceRef",
        "variableName": "spaceRef"
      }
    ],
    "concreteType": "SimulatorSpacePublic",
    "kind": "LinkedField",
    "name": "simulatorSpacePublicMutation",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "days",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "SimulatorSpacePublicPrice",
        "kind": "LinkedField",
        "name": "price",
        "plural": false,
        "selections": [
          (v5/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "SimulatorSpacePublicPrice",
        "kind": "LinkedField",
        "name": "priceByDates",
        "plural": false,
        "selections": (v6/*: any*/),
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "SimulatorSpacePublicPrice",
        "kind": "LinkedField",
        "name": "riderFees",
        "plural": false,
        "selections": (v6/*: any*/),
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "SimulatorSpacePublicPrice",
        "kind": "LinkedField",
        "name": "riderOwing",
        "plural": false,
        "selections": (v6/*: any*/),
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "resumeSimulatorSpacePublicMutation",
    "selections": (v7/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v4/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "resumeSimulatorSpacePublicMutation",
    "selections": (v7/*: any*/)
  },
  "params": {
    "cacheID": "8e596a70ce2304b7709f4448b642e390",
    "id": null,
    "metadata": {},
    "name": "resumeSimulatorSpacePublicMutation",
    "operationKind": "mutation",
    "text": "mutation resumeSimulatorSpacePublicMutation(\n  $category: String\n  $spaceRef: String\n  $riderRef: String\n  $riders: Int\n  $datesSelected: JSONObject\n) {\n  simulatorSpacePublicMutation(category: $category, spaceRef: $spaceRef, riderRef: $riderRef, riders: $riders, datesSelected: $datesSelected) {\n    days\n    price {\n      excl_tax\n    }\n    priceByDates {\n      excl_tax\n      incl_tax\n    }\n    riderFees {\n      excl_tax\n      incl_tax\n    }\n    riderOwing {\n      excl_tax\n      incl_tax\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '872d640a8a2e5ea4b57985a27cfea01e';

module.exports = node;
